/**
 * Scope-filter - прикладные поля вне scope (другие поля панели, чужие
 * field'ы pagesData) — дропаются. Если форма реально нуждается в значении вне scope, 
 * скрипт должен сделать явный `en.putData(...)`.
 */

/** Платформенные глобальные поля и document-поля, которые всегда пробрасываем. */
const ALWAYS_PASS_KEYS = new Set<string>([
  '_id',
  '_typeId',
  '_versionId',
  '_typeVersionId',
  '_typeVersion',
  'ProcessInstances',
  'exception',
  'doActionId',
  'openPage',
  'elementConditions',
  'reloadActions',
])

function isAlwaysPass(key: string): boolean {
  if (!key) return false
  if (key.startsWith('$')) return true
  return ALWAYS_PASS_KEYS.has(key)
}

function isAuxOfReloadedElement(key: string, reloadedFieldName: string): boolean {
  if (!reloadedFieldName) return false
  return (
    key === reloadedFieldName ||
    key.startsWith(`${reloadedFieldName}_`) ||
    key.startsWith(`${reloadedFieldName}__`)
  )
}


export function isInlineTableReloadContext(
  tableFieldName: string,
  fields: Record<string, unknown> | null | undefined,
): boolean {
  const name = String(tableFieldName ?? '').trim()
  if (!name || !fields || typeof fields !== 'object') {
    return false
  }
  return (
    Object.prototype.hasOwnProperty.call(fields, `${name}__rowNum`) ||
    Object.prototype.hasOwnProperty.call(fields, `${name}__column`)
  )
}

function pickInlineTableReloadAuxFields(
  out: Record<string, unknown>,
  tableFieldName: string,
): Record<string, unknown> {
  const name = String(tableFieldName ?? '').trim()
  if (!name) return {}
  const prefix = `${name}__`
  const aux: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(out)) {
    if (key.startsWith(prefix)) {
      aux[key] = value
    }
  }
  return aux
}

export function buildInlineTableReloadPayload(
  out: Record<string, unknown>,
  tableFieldName: string,
  ...scalarLayers: Array<Record<string, unknown> | null | undefined>
): Record<string, unknown> {
  const formScalars: Record<string, unknown> = {}
  for (const layer of scalarLayers) {
    if (!layer || typeof layer !== 'object') continue
    Object.assign(formScalars, layer)
  }
  return { ...formScalars, ...pickInlineTableReloadAuxFields(out, tableFieldName) }
}

export function filterReloadWidePoolByScope(
  widePool: Record<string, unknown> | null | undefined,
  outScope: Record<string, unknown> | null | undefined,
  reloadedFieldName: string,
): Record<string, unknown> {
  if (!widePool) return {}
  const allowedFromOut = outScope && typeof outScope === 'object' ? outScope : {}
  const omitInlineTableBody = isInlineTableReloadContext(reloadedFieldName, allowedFromOut)
  const out: Record<string, unknown> = {}
  for (const [key, value] of Object.entries(widePool)) {
    if (omitInlineTableBody && key === reloadedFieldName) {
      continue
    }
    if (
      Object.prototype.hasOwnProperty.call(allowedFromOut, key) ||
      isAuxOfReloadedElement(key, reloadedFieldName) ||
      isAlwaysPass(key)
    ) {
      out[key] = value
    }
  }
  return out
}
